import Image from 'next/image'
import { Tile, TileCaption, TileImage } from '@mc/design-system'

export interface SquareTileProps {
  text: string
  imageUrl: string
  hasAsterisk?: boolean
}

export const SquareTile = ({
  text,
  imageUrl,
  hasAsterisk,
}: SquareTileProps) => (
  <Tile aspectRatio='1x1'>
    <TileImage
      className='mc-corners--md'
      image={
        <Image
          fill
          src={imageUrl}
          alt={text}
          sizes='(max-width: 960px) 50vw, 25vw'
        />
      }
    />
    <TileCaption className='mc-text-h4 mc-pb-2 mc-px-2' position='left bottom'>
      {text}
      {hasAsterisk && <span className='mc-text-h4 mc-opacity--muted'>*</span>}
    </TileCaption>
  </Tile>
)
